import { downloadFile } from '@/utils/pageUtils'

export default {
  customDownloadDocument({ commit }, params) {
    var host = window.location.origin
    var url = host + '/wsp/' + params.module + '/' + params.action + '?id=' + params.params.id
    downloadFile(url)
  }
}
